<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>De JaarBalans</h2>
<div modal-content class="modal-body">
    <p>
        Na ieder jaar maken we de balans op. Hebben we de premie goed ingeschat om alle schades te dekken? Dan hebben we
        niet te veel in rekening gebracht bij onze klanten. Is er geld over van het bedrag wat we hebben gereserveerd
        voor schade? Dan geven we dan gewoon weer terug.
    </p>
    <p>
        <picture>
            <source
                type="image/webp"
                [attr.defaultImage]="'/assets/default-image-1x1.png'"
                [attr.lazyLoad]="'/assets/shared/02_home/jaarbalans-nl.webp'"
            />
            <img
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/02_home/jaarbeloning-geld-over-730x313.png"
                alt="InShared Jaarbeloning"
                class="img-responsive"
            />
        </picture>
    </p>
    <a class="link-secondary link-secondary--more" (click)="close()" [href]="'/' + appRoutesEnum.AnnualReward">
        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
        Lees meer over de JaarBalans
    </a>
</div>
